<template>
  <v-container fluid class="pt-10">
    <v-row dense no-gutters class="pa-0">
      <v-col cols="9"></v-col>
      <!--<v-col cols="12" class="d-flex justify-end px-2" style="gap:8px">-->
      <v-col cols="3" class="d-flex justify-space-around">
        <span v-for="opt in options" :key="opt.value" style="font-size: .8rem;">{{ opt.text }}</span>
      </v-col>
    </v-row>

    <v-divider />

    <div v-for="section in sections" :key="section.name" class="pa-0">
      <v-row dense align="center" :style="section.headerStyle">
        <v-col cols="9" class="px-2">
          <span style="font-size:18px; font-weight:500;">{{
            section.name
          }}</span>
        </v-col>
        <v-col cols="3" class="d-flex justify-space-around px-2">
          <v-tooltip
            v-for="opt in options"
            :key="opt.value"
            bottom
            color="#000000"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                :v-bind="attrs"
                v-on="on"
                :disabled="isReadOnly || section.disabled"
                @click="setSection(section.fields, opt.value)"
                class="radioButtonSelector"
              >
                <v-img src="img/radiobutton-all.svg" style="width: 16px; height: 30px;"/>
              </v-btn>
            </template>
            <span>{{ $t('wkt.admin.profiles.edit-window.select_all.tooltip') }}</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-row
        v-for="item in section.items"
        :key="item.field"
        dense
        no-gutters
        align="center"
        class="px-0"
      >
        <v-col cols="9" class="px-2">
          <span style="font-size:14px" :style="item.labelStyle">{{ item.label }}</span>
        </v-col>
        <v-col cols="3" class="d-flex justify-space-around px-2">
          <v-radio-group
            v-model="data[item.field]"
            @change="$emit('update:data', data)"
            dense
            row
            no-gutters
            :disabled="isReadOnly || section.disabled"
            class="adminsRadButtonsRow"
          >
            <v-radio
              v-for="opt in options"
              :key="opt.value"
              :value="opt.value"
              label=""
              hide-details
              class="mx-1"
            />
          </v-radio-group>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
export default {
    name: "SuperAdminTab", 
    props: ['data', 'isReadOnly'],
    data () {
        return {
            options: [
              { value: 0, text: this.$t('wkt.admin.profiles.edit-window.not_allowed') },
              { value: 1, text: this.$t('wkt.admin.profiles.edit-window.read_only') },
              { value: 2, text: this.$t('wkt.admin.profiles.edit-window.read_write') },
            ],
            sections: [
                {
                    name: this.$t('wkt.admin.profiles.edit-window.admin_group'),
                    headerStyle: "background-color:#F8F8F8; font-size:20px; font-weight:500; color:black",
                    fields: ["moduleCustomers","modulePartners","moduleTransactions","modulePurchases","modulePrices",
                        "moduleVouchers","moduleOnBoardMessages","moduleWebhooks","moduleReportType","moduleKiosk","moduleAdminConfig"
                    ],
                    items: [
                        { label: this.$t('wkt.admin.profiles.edit-window.customers'), field: "moduleCustomers" },
                        { label: this.$t('wkt.admin.profiles.edit-window.partners'), field: "modulePartners" },
                        { label: this.$t('wkt.admin.profiles.edit-window.transactions'), field: "moduleTransactions" },
                        { label: this.$t('wkt.admin.profiles.edit-window.purchases'), field: "modulePurchases" },
                        { label: this.$t('wkt.admin.profiles.edit-window.prices'), field: "modulePrices" },
                        { label: this.$t('wkt.admin.profiles.edit-window.vouchers'), field: "moduleVouchers" },
                        { label: this.$t('wkt.admin.profiles.edit-window.onBoardMessages'), field: "moduleOnBoardMessages" },
                        { label: this.$t('wkt.admin.profiles.edit-window.webhooks'), field: "moduleWebhooks" },
                        { label: this.$t('wkt.admin.profiles.edit-window.reportType'), field: "moduleReportType" },
                        { label: this.$t('wkt.admin.profiles.edit-window.kiosk'), field: "moduleKiosk" },
                        { label: this.$t('wkt.admin.profiles.edit-window.adminconfig'), field: "moduleAdminConfig" },
                    ],
                }
            ]
        }
    },
    methods: {
      setSection(fields, value) {
        fields.forEach((f) => {
            if (this.$set) {
            this.$set(this.data, f, value);
            }
        });
        this.$emit('update:data', this.data)
      },
    },
}
</script>